import { registerPlugin } from "@capacitor/core";
export const GigSyncLLM = registerPlugin("GigSyncLLM", {
    web: () => import("./web.js").then((m) => new m.GigSyncLLMWeb()),
});
export { MODEL } from "./catalog.js";
export * from "./definitions.js";
//# sourceMappingURL=index.js.map